import styled from 'styled-components';

export const ItemContainer = styled.div`
  display: flex;
  padding: 4px 12px;
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) => theme.palette.common.white};
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: 1px solid ${({ theme }) => theme.palette.grey[400]};
  gap: 8px;

  // 24px is the width of the icon
  max-width: calc(100% - 24px);
  min-width: calc(100% - 24px);
`;

export const InactiveItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  padding-left: 12px;
  margin: 4px 0;
  background: ${({ theme }) => theme.palette.common.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  color: ${({ theme }) => theme.palette.text.disabled};
  p {
    margin: 0;
    padding: 0;
  }
`;
